<div class="modal-header"><h2 class="modal-title">Bulk Edit</h2></div>
<div class="modal-body" (keyup.esc)="close()">
    <dx-form *ngIf="bulkInfo" [formData]="bulkInfo">
        <dxi-item dataField="vendor" [label]="{ text: 'Preferred Vendor' }" editorType="dxSelectBox" [editorOptions]="{ items: vendors, displayExpr: 'companyName' }"> </dxi-item>
        <dxi-item dataField="category"> </dxi-item>
        <dxi-item dataField="fontColor" editorType="dxColorBox" [editorOptions]="{ editAlphaChannel: true }"></dxi-item>
        <dxi-item dataField="isAssembly" [label]="{ text: 'Is Assembly' }" editorType="dxSelectBox" [editorOptions]="{ items: isAssemblyOptions }"> </dxi-item>

    </dx-form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()" [disabled]="processing" >Save</button>
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
</div>
